module.exports = __webpack_public_path__ + "static/media/baby_yoda@2x.21b75423.png";